const PAYMENT_METHODE_TYPE = {
    DIRECT_DEBIT: 'DIRECT_DEBIT',
}

const PAYMENT_TYPE = {
    INVOICE_CORRECTION: 'INVOICE_CORRECTION',
    BANK_TRANSFER: 'BANK_TRANSFER',
    DIRECT_DEBIT: 'DIRECT_DEBIT',
    CASH: 'CASH',
    CREDIT_CARD: 'CREDIT_CARD',
    PAYPAL: 'PAYPAL'
}

const BANK_ACCOUNT = {
    DEPOSIT_ACCOUNT: 'DEPOSIT_ACCOUNT',
    COMPANY_ACCOUNT: 'COMPANY_ACCOUNT'
}


exports = module.exports = {
    PAYMENT_METHODE_TYPE,
    PAYMENT_TYPE,
    BANK_ACCOUNT
}